import { AdapterManager } from '../adapter/manager/AdapterManager.js';
import { AdapterType } from '../adapter/manager/types.js';
import { BrowserRtcApi } from '../adapter/browser/BrowserRtcApi.js';
import { RtcPluginCore } from './RtcPlugin.js';
export { RtcPluginCore } from './RtcPlugin.js';
export { RtcController } from './RtcController.js';
export { RtcEvent, RtcEventBus } from './RtcEvent.js';
import 'tslib';
import 'long';
import '../proto/index.js';
import '../core/consts.js';
import '../core/metrics/logger.js';
import '../core/metrics/monitor.js';
import '../core/service/RuntimeContext.js';
import '../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import '../core/model/Message.js';
import 'js-md5';
import '../core/utils/lz4.js';
import '../core/utils/serializer.js';
import '../core/utils/ticker.js';
import '../adapter/abstract/IMNetApi.js';
import '../core/options.js';
import '../core/utils/uuid.js';
import '../core/service/ConversationManager.js';
import '../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../core/plugin/DbProxy.js';
import '../core/metrics/trackerTypes.js';
import '../core/model/CommandMessage.js';

class RtcPlugin extends RtcPluginCore {
    initAdapter() {
        AdapterManager.setAdapter(AdapterType.RtcApi, BrowserRtcApi);
    }
}

export { RtcPlugin };
//# sourceMappingURL=index-browser.js.map
